import { useEffect } from 'react';
import api from '../lib/api';

// Convert Drive/Dropbox share URLs to direct image URLs (mirrors BrandLogo)
function toDirectImg(url) {
  if (!url || typeof url !== 'string') return url;
  const m1 = url.match(/drive\.google\.com\/file\/d\/([^/]+)\//);
  if (m1) return `https://drive.google.com/uc?export=view&id=${m1[1]}`;
  const m2 = url.match(/drive\.google\.com\/open\?id=([^&]+)/);
  if (m2) return `https://drive.google.com/uc?export=view&id=${m2[1]}`;
  if (url.includes('dropbox.com') && url.includes('dl=0')) return url.replace('dl=0', 'raw=1');
  return url;
}

function setFavicon(href) {
  if (!href) return;
  // Remove existing favicons
  document.querySelectorAll("link[rel*='icon']").forEach(el => el.remove());
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = href;
  document.head.appendChild(link);
  // Also set apple-touch-icon for iOS
  const apple = document.createElement('link');
  apple.rel = 'apple-touch-icon';
  apple.href = href;
  document.head.appendChild(apple);
}

/**
 * Hook component that updates document.title and favicon from /settings/public.
 * Place once near the app root. Re-runs on focus to pick up admin changes.
 */
export default function BrandHead() {
  useEffect(() => {
    const apply = async () => {
      try {
        const r = await api.get('/settings/public');
        const s = r.data || {};
        const name = s.restaurant_name || s.logo_text || 'Reservierung';
        document.title = `${name} – Tischreservierung`;
        if (s.logo_url) setFavicon(toDirectImg(s.logo_url));
      } catch {
        // ignore, keep static title
      }
    };
    apply();
    const onFocus = () => apply();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);
  return null;
}
